/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  // Definerer klassen 'TermsCheckbox', som arver fra HTMLElement
  class TermsCheckbox extends HTMLElement {
    constructor() {
      // Kald til super() for at initialisere HTMLElement
      super();
    }

    connectedCallback() {
      // Hent værdien fra data-append attributten, der bruges til at identificere checkboxen
      this.append = this.dataset.append;
      // Find checkboxen med et id, der matcher "CartTerms" + append værdien
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      // Find checkout-knappen med klassen "button checkout-button" i forælder elementet
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');

      this.terms_checkbox.addEventListener('change', () => {
        // Hvis checkboxen er tjekket fjernes disabled, ellers tilføjes disabled
        this.checkout_button.disabled = !this.terms_checkbox.checked;
      });
      
      // Hvis både checkboxen og knappen findes...
      if (this.terms_checkbox && this.checkout_button) {
        // Sætter en brugerdefineret fejlbesked, som vises, hvis checkboxen ikke er tjekket
        this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);

        // Tilføj en klik-eventlistener til checkout-knappen
        this.checkout_button.addEventListener('click', (e) => {
          // Hvis checkboxen ikke er tjekket...
          if (!this.terms_checkbox.checked) {
            // Vis fejlbesked og sæt fokus på checkboxen
            this.terms_checkbox.reportValidity();
            this.terms_checkbox.focus();
            // Forhindrer standard handling (f.eks. form submission)
            e.preventDefault();
          }
        });
      }
    }
  }
  // Registrer custom elementet, så det kan bruges med <terms-checkbox></terms-checkbox>
  customElements.define('terms-checkbox', TermsCheckbox);
}
